// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"b6124a07","189":"f762547e","259":"ee547ac3","284":"28655a8f","304":"d685b940","325":"89698de9","359":"3cc5052d","368":"4e77b911","404":"3586c7e6","443":"068d0298","518":"0b6f51a3","818":"14320f9a","900":"9d69ddbb","953":"0932646a","985":"b504af55"}[chunkId] + ".chunk.js";
};